import React from 'react';
import { Select, Form } from 'antd';
import { useSelector } from 'react-redux';

import { selectGroups } from '../../../features/groups/groupSlice';
import { IUser } from '../../../features/users/usersSlice';
import {
    ICompany,
} from '../../../features/company/companySlice';
import { getTranslations } from '../../../features/translations/translationsUtils';

interface CompanyFieldProps {
    newObject?: IUser,
    value?: string | ICompany,
    setNewObject: Function,
    companyId?: string,
}

export const GroupField: React.FunctionComponent<CompanyFieldProps> = (props) => {
    const { value, setNewObject, newObject, companyId } = props;
    const list = useSelector(selectGroups);
    return <Form.Item
        initialValue={newObject?.groupId}
        name="groupId"
        wrapperCol={{ sm: 24 }}
        label={getTranslations('USERS_SUPERVISION_GROUP')}
        rules={[{ required: true, message: getTranslations('GENERAL_REQUIRED') }]}
    >
        <Select
            placeholder={getTranslations('USERS_ASSIGN_SUPERVISION_GROUP')}
            value={value?.toString()}
            style={{ width: '100%' }}
            onChange={(value) => {
                setNewObject({ ...newObject, groupId: value })
            }}>
            {list.filter(group => {
                return group.company === companyId
            }).map(group => {
                return <Select.Option key={group._id} value={group._id}>{group.name}</Select.Option>
            })}
        </Select>
    </Form.Item>
};